'use strict';

// возвратить массив элементов, у которых такой класс
// dom - родительский элемент
// cn - искомый класс
function get_element_from_class(dom, cn)
{
    let res = [];

    recursiveSearch(dom, cn, res);
    /*
    for(let i in dom.children)    
        if(dom.children[i].className.includes(cn)) return dom.children[i];
    */

    return res;
}

// рекурсивная функция поиска
// arr - элемент в котором ищем
// cn - имя класса
// res - массив, в который добавляем
function recursiveSearch(arr, cn, res)
{
    for(let i in arr.children)
    {   
        let element = arr.children[i];
        if(element === undefined || element == null || element == "" || element.className === undefined || element.className == null) continue;
        if(element.className.includes(cn))  res.push(element);
        recursiveSearch(element, cn, res);
    }
}

export default get_element_from_class;